import Feature from 'ol/Feature.js';
import Geolocation from 'ol/Geolocation.js';
import Map from 'ol/Map.js';
import Point from 'ol/geom/Point.js';
import View from 'ol/View.js';
import {Circle as CircleStyle, Fill, Stroke, Style} from 'ol/style.js';
import {OSM,BingMaps, Vector as VectorSource} from 'ol/source.js';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer.js';
import Control from 'ol/control/Control';
import Draw from 'ol/interaction/Draw.js';
import LayerGroup from 'ol/layer/Group';

const raster1 = new LayerGroup({
  layers:[  new TileLayer({
  source: new BingMaps({
    key: 'Ak_BhUnNAigKZkF64lHRFwDeBR8KZpEeokYgA3cTNHmOu8i0_dHO9AByeRhLWpQV',
    imagerySet: 'AerialWithLabelsOnDemand',})}),
    ],
  });

  const raster2=new LayerGroup({
    layers: [
      new TileLayer({
        source: new OSM(),
    
  
      }),
      
    ],
  });


const view = new View({
  center: [0, 0],
  zoom: 2,
});

const map = new Map({
  layers: [raster2
      ],
  target: 'map',
  view: view,
});

document.getElementById('basemap').addEventListener('click',function(){
  var x=document.getElementById('osm');
  var y=document.getElementById('bingmap');
  if (x.checked==true){
    map.setLayerGroup(raster2);
    }
  else{
    map.setLayerGroup(raster1);
    }
  });




const geolocation = new Geolocation({
  // enableHighAccuracy must be set to true to have the heading value.
  trackingOptions: {
    enableHighAccuracy: true,
  },
  projection: view.getProjection(),
});

function el(id) {
  return document.getElementById(id);
}

el('track').addEventListener('change', function () {
  
  geolocation.setTracking(this.checked);

});

// update the HTML page when the position changes.
geolocation.on('change', function () {
  var coord=[];
  coord=geolocation.getPosition();
  el('accuracy').value = (geolocation.getAccuracy()).toFixed(2) + ' [m]';
  el('altitude').value = (geolocation.getAltitude()).toFixed(2) + ' [m]';
  el('latitude').value = (coord[0]).tofixed(2)+ ' [m]';
  el('longtitude').value = (coord[1]).tofixed(2)+ ' [m]';
  el('heading').value = ((geolocation.getHeading())*180/(Math.PI)).tofixed(2) + ' [deg]';
  el('speed').value = (geolocation.getSpeed()).toFixed(2) + ' [m/s]';
});

// handle geolocation error.
geolocation.on('error', function (error) {
  const info = document.getElementById('info');
  info.innerHTML = error.message;
  info.style.display = '';
});

const accuracyFeature = new Feature();
geolocation.on('change:accuracyGeometry', function () {
  accuracyFeature.setGeometry(geolocation.getAccuracyGeometry());
});

const positionFeature = new Feature();
positionFeature.setStyle(
  new Style({
    image: new CircleStyle({
      radius: 6,
      fill: new Fill({
        color: 'red',
      }),
      stroke: new Stroke({
        color: 'yellow',
        width: 2,
      }),
    }),
  }),
);


new VectorLayer({
  map: map,
  source: new VectorSource({
    features: [accuracyFeature, positionFeature],
  }),
});

//map.addLayer(layer);




geolocation.on('change:position', function () {
  const coordinates = geolocation.getPosition();
  positionFeature.setGeometry(coordinates ? new Point(coordinates) : null);
  if (!source.isEmpty()) {
    map.getView().fit(source.getExtent(), {
      maxZoom: 18,
      duration: 500,
    });
  }
  
});


/////



